import EndpointsOverlay from '../../@opentripplanner/endpoints-overlay/src'
import { connect } from 'react-redux'

import {
  clearLocation,
  forgetPlace,
  rememberPlace,
  setLocation
} from '../../actions/map'
import { getActiveSearch, getShowUserSettings } from '../../@opentripplanner/core-utils/src/state'

// connect to the redux store

const mapStateToProps = (state, ownProps) => {
  // Use query from active search (if a search has been made) or default to
  // current query is no search is available.
  const activeSearch = getActiveSearch(state.otp)
  const query = activeSearch ? activeSearch.query : state.otp.currentQuery
  const showUserSettings = getShowUserSettings(state.otp)
  const { from, to } =  query
  return {
    fromLocation:  state.otp.ui.viewedRoute ? null : from,
    locations: state.otp.user.locations,
    showUserSettings,
    toLocation:  state.otp.ui.viewedRoute ? null : to,
    visible: true
  }
}

const mapDispatchToProps = {
  forgetPlace,
  rememberPlace,
  setLocation,
  clearLocation
}

export default connect(mapStateToProps, mapDispatchToProps)(EndpointsOverlay)
